module.exports = __webpack_public_path__ + "static/media/W2.528532c4.png";